import { useContext, useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableFilterReturn, TableFooter, TableHead, TableHeaderWrap, TableRow, } from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import moment from "moment";
import StatusChip from "../../../../component/ui/chip/status";
import AvatarProfile from "../../../../component/ui/profile";
import { TitleHeading } from "../../../../component/ui/layout";
import { GlobalContext } from "../../../../context/Context";
// import PPCProductSummary from "./inner-pages/product-summary";
// import PPCWebsiteSummary from "./inner-pages/website-summary";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Link } from "react-router";
import { Brand, DateRange, OperationName } from "../../../../component/icons/filter-icon";

const ProductSummaryList = () => {
  let {state} = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [footer, setFooter] = useState({});
  const [currentProductId, setCurrentProductId] = useState("");
  const [currentWebsiteId, setCurrentWebsiteId] = useState("");
  const [defaultRange, setDefaultRange] = useState("");

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-ppc-product-brand-view${extraUrl}`,
      });
      setList(res.data);
      setTableHeaders(res.headers);
      setSaveFilter(res?.custom_filters);
      setFooter(res?.footer)
      setIsLoading(false);
      setDefaultRange(res?.date_filter)
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "brand_id",
      label: "Brand",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns.brandList,
      dropdownKey: "name",
      dropdownVal: "id",
      isMulti: true,
      Icon: Brand
    },
    {
      name: "service_id",
      label: "Service",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: state.getDropdowns.serviceList,
      dropdownKey: "name",
      dropdownVal: "id",
      isMulti: true,
      Icon: OperationName
    },
    {
      name: "date_range",
      label: "Date Range",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
      Icon: DateRange
    }
  ];

  const onInnerPageClose = () => {
    setCurrentProductId("");
    setCurrentWebsiteId("");
  }

  const [openGroups, setOpenGroups] = useState({});
  const toggleGroup = (index) => {
    setOpenGroups((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <>
      {/* {currentProductId ?
        <PPCProductSummary id={currentProductId} onClose={onInnerPageClose} isAlreadyDateUse={filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length ? true : false} preDate={filterReturn?.find(eachFilter => eachFilter?.name == "date_range")} />
        :
        (currentWebsiteId) ? 
        <PPCWebsiteSummary id={currentWebsiteId} onClose={onInnerPageClose} isAlreadyDateUse={filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length ? true : false} preDate={filterReturn?.find(eachFilter => eachFilter?.name == "date_range")} />
        :
        null
      } */}
      <>
        <div className={Style.leaveMainPage}>
          <TableFilterReturn
            filterReturn={(!filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length) ?
              [
                {
                  "name": "date_range",
                  "label": "Date Range",
                  "selectedOpt": "is",
                  "value": defaultRange,
                  "isCrossDisable": true
                },
                ...filterReturn
              ]
              : filterReturn
            }
            onChange={(filters) => {
              setFilterReturn(filters);
              getData({ filter: filters });
            }}
          />
          <div className={Style.report_table__header}>
            <TitleHeading title={'Products Summary'} />

            <div className={Style.bpfl_action}>
              <Tooltip
                className={Style.bpfl_actionItems}
                content={"Table Filter"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                    }`}
                  onClick={() => {
                    setShowModalFilterTable(true);
                  }}
                >
                  <div className={Style.icon}>
                    <FilterFunnel01Icon />
                  </div>
                </div>
              </Tooltip>
              {/* <div className={`${Style.bpfl_action}`}>
                <Tooltip
                  className={`${Style.bpfl_actionItems}`}
                  content={"Customize Table"}
                  position={"left center"}
                >
                  <div
                    className={`${Style.bpfl_actionBtn}`}
                    onClick={() => {
                      setShowModalCustomizeTabs(true);
                    }}
                  >
                    <div className={Style.icon}>
                      <LayoutTopIcon />
                    </div>
                  </div>
                </Tooltip>
              </div> */}
            </div>
          </div>

          <div className={Style.LeaveBody}>
            {isLoading ? (
              <InnerLoader />
            ) : !lists?.length ? (
              <div className="w-full h-full flex items-center justify-center">
                <DataNotFound title={"Lists"} />
              </div>
            ) : (
              <>
                <TableCard>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell header sticky className={"!min-w-[50px] !max-w-[50px]"}><TableHeaderWrap>S.no</TableHeaderWrap></TableCell>
                        <TableCell header sticky className={"!left-[50px]"}><TableHeaderWrap>Product</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>Websites</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>Spend</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>Revenue</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>ROAS</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>Leads</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>Conversions</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>CPL</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>Clicks</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>Impressions</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>CPA</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>CTR</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>CPC</TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap>% Budget</TableHeaderWrap></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {lists?.map((eachList, index) => {
                        return (
                          <>
                            <TableRow key={`${index}`} className="cursor-pointer" onClick={() => toggleGroup(index)}>
                              <TableCell sticky className={"!text-[16px] !font-bold !bg-[#EDEDF4]"} colSpan={2}>
                                {/* <div className="flex items-center gap-[10px]">
                                  <div className="font-medium leading-5 underline decoration-dotted cursor-pointer hover:opacity-70" onClick={() => setCurrentProductId(eachList?.product_id)}>{eachList?.product}</div>
                                </div> */}
                                <div
                                  className={`${Style.tableActionArea} !gap-4`}
                                >
                                  <div className="flex items-center gap-3">
                                    <span className="flex items-center">
                                      {openGroups[index] ? (
                                        <ChevronUp size={18} />
                                      ) : (
                                        <ChevronDown size={18} />
                                      )}
                                    </span>
                                    <div className="font-medium leading-5">
                                      {eachList?.product}
                                    </div>
                                  </div>

                                  <div className={Style.tableActionAreaBtnGrpup}>
                                    <Link
                                      to={`/summary/product/product-summary/${eachList?.product_id}?daterange=${filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length ? JSON.stringify(filterReturn?.find(eachFilter => eachFilter?.name == "date_range")) : ""}`}
                                      target="_blank"
                                      className={
                                        "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                      }
                                    >
                                      <div className={Style.icon} style={{ color: "#007AFF" }}>
                                        <NewEyeIcon className="h-4.5 w-4.5" />
                                      </div>
                                    </Link>
                                  </div>

                                </div>
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {/* {(eachHead?.key == "profit_loss" || eachHead?.key == "fresh_roi" || eachHead?.key == "total_roi") ?
                                  <span className={eachList[eachHead?.key]?.includes("-") ? "text-red-500" : (eachList[eachHead?.key] == "$0.00" || eachList[eachHead?.key] == "0.00%") ? "" : "text-green-500"}>{eachList[eachHead?.key]}</span>
                                  :
                                  eachList[eachHead?.key] ?? "-"
                                } */}
                                {eachList?.websites_count}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.spend}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.revenue}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.roas}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.leads}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.conversions ?? 0}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.cpl}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.clicks}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.impressions}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.cpa ?? 0}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.ctr}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.cpc}
                              </TableCell>
                              <TableCell className={"!bg-[#EDEDF4]"}>
                                {eachList?.budget_pct}%
                              </TableCell>
                            </TableRow>
                            {openGroups[index] && (eachList?.websites?.map((eachWeb, j) => (
                              <TableRow key={`${j}-${index}`}>
                                <TableCell sticky>{j + 1}</TableCell>
                                <TableCell sticky className={"!left-[50px]"}>
                                  {/* <div className="flex items-center gap-[10px]">
                                    <div className="font-medium leading-5 underline decoration-dotted cursor-pointer hover:opacity-70" onClick={() => setCurrentWebsiteId(eachWeb?.website_id)}>{eachWeb?.name}</div>
                                  </div> */}
                                <div
                                  className={`${Style.tableActionArea} !gap-4`}
                                >
                                  <div className="flex items-center gap-3">
                                    <div className="font-medium leading-5">
                                      {eachWeb?.name}
                                    </div>
                                  </div>

                                  <div className={Style.tableActionAreaBtnGrpup}>
                                    <Link
                                      to={`/summary/product/website-summary/${eachWeb?.website_id}?daterange=${filterReturn?.find(eachFilter => eachFilter?.name == "date_range")?.value?.length ? JSON.stringify(filterReturn?.find(eachFilter => eachFilter?.name == "date_range")) : ""}`}
                                      target="_blank"
                                      className={
                                        "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                      }
                                    >
                                      <div className={Style.icon} style={{ color: "#007AFF" }}>
                                        <NewEyeIcon className="h-4.5 w-4.5" />
                                      </div>
                                    </Link>
                                  </div>

                                </div>
                                </TableCell>
                                <TableCell>
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.spend}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.revenue}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.roas}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.leads}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.conversions ?? 0}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.cpl}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.clicks}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.impressions}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.cpa ?? 0}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.ctr}
                                </TableCell>
                                <TableCell>
                                  {eachWeb?.cpc}
                                </TableCell>
                                <TableCell>
                                </TableCell>
                              </TableRow>
                            )))}
                          </>
                        );
                      })}
                    </TableBody>

                    <TableFooter>
                      <TableRow>
                        <TableCell header sticky className="!font-bold !bg-[#f6f7f7]" colSpan={2}>Summary</TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]"></TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]">{footer?.spend}</TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]">{footer?.revenue}</TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]"></TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]">{footer?.leads}</TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]"></TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]"></TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]">{footer?.clicks}</TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]">{footer?.impressions}</TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]"></TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]"></TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]"></TableCell>
                        <TableCell header className="!font-bold !bg-[#f6f7f7]"></TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableCard>
              </>
            )}
          </div>
        </div>
      </>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-brand-performance-analysis"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
          }}
          apiUrl="get-brand-performance-analysis"
        />
      )}
    </>
  );
};

export default ProductSummaryList;
